<template>
  <div class="print__doc">
    <div class="page-break">
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >Договор&nbsp;</span
          ></strong
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />
          <strong
            >Розничной купли-продажи товара по образцам или каталогу №
            <u>
              <slot name="orderNumber" />
              <br />&nbsp;</u
            ></strong
          ></span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
        >
          <slot name="topDate" />
        </span>
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />
          <strong>ИП Пономарев Алексей Михайлович&nbsp;</strong>&nbsp; в лице
          <strong>&quot;Пономарева Алексея Михайловича&quot;</strong>, с одной
          стороны, именуемый в дальнейшем Продавец,
          <span
            >и <strong><slot name="topFullname"/></strong
          ></span>
          именуемый(ая) в дальнейшем Розничный Покупатель, а вместе именуемые
          &quot;Стороны&quot;, заключили настоящий договор о
          нижеследующем:</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >1. ПРЕДМЕТ ДОГОВОРА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >1.1. По настоящему Договору Продавец обязуется передать в
          собственность Покупателя Товар по цене, в ассортименте и количестве,
          указанным в согласованном сторонами Приложении №1 к Договору
          (далее-Спецификация), дизайн-проект и спецификацию, а Покупатель
          обязуется оплатить и принять Товар в соответствии с условиями
          настоящего Договора.<br />&nbsp;1.2. Приложение №2 к Договору (далее -
          Дизайн-проект) &nbsp;является демонстрацией совместного использования
          отдельных Товаров и материалов Продавца, подлежащих передаче
          Покупателю.<br />&nbsp;1.3. Действие настоящего Договора отдельно
          распространяется на каждый Товар, самостоятельно поименованный в
          Спецификации к Договору.<br />&nbsp;1.4. Если использование различных
          Товаров, подлежащих передаче Покупателю по настоящему Договору,
          предполагает их соединение и использование по общему назначению
          (сложная вещь), то действие настоящего договора распространяется
          отдельно на каждый составляющий элемент (комплектующие) такой вещи.<br />&nbsp;1.5.
          &nbsp;Размещение образцов готовых мебельных комплектов в каталогах,
          проспектах, буклетах, в торговых залах и иных местах продажи товаров
          является демонстрацией возможного совместного использования отдельных
          Товаров, предложенных к продаже Покупателям. Покупатель, подписывая
          настоящий Договор гарантирует, что ознакомлен с этой информацией.
          Покупая Товары по предложенным образцам, Покупатель согласен с тем,
          что Предметом заключенного с Продавцом Договора купли-продажи являются
          отдельные элементы представленных комплектов мебели. &nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >1.6. Товар, передаваемый по настоящему Договору, имеет
          индивидуально-определенные свойства, так как комплектуется в
          соответствии с индивидуальными &nbsp;техническими параметрами ,
          согласованными с Покупателем, и согласно п.4 ст 26. 1 &nbsp;Закона
          &laquo;О защите прав потребителей&raquo; Покупатель не в праве
          отказаться от такого Товара надлежащего качества и предупрежден и с
          этим согласен.<br />&nbsp;1.7. Продавец не осуществляет услуги по
          доставке, подъему, сборке и установке Товаров. Данные услуги
          осуществляются сторонними партнерами (контрагентами)
          Продавца.&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >2. ОБЩИЕ УСЛОВИЯ</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >2.1. Под Товаром Стороны понимают отдельные предметы мебели и
          аксессуары к ним, которые имеют собственное наименование, цену.
          &nbsp;<strong><br />&nbsp;</strong>2.2. Ассортимент, комплектность,
          технические характеристики, количество и цена Товара указываются
          &nbsp;в Спецификации &nbsp; (Приложение №1), являющейся неотъемлемой
          частью настоящего Договора.<strong><br />&nbsp;</strong>2.3. Товары,
          поставляемые в рамках настоящего Договора, могут иметь разного
          производителя.<strong><br />&nbsp;</strong>2.4. Производство и
          комплектация Товара осуществляется в соответствии со Спецификацией.
          (Приложение №1) и/или (Приложение №1.1)<strong><br />&nbsp;</strong
          >2.5. Покупатель вправе вносить изменения (дополнения) в утвержденную
          Спецификацию (Приложение №1) в течение 24 часов с момента подписания
          Договора путем сообщения необходимой информации в письменном виде по
          адресу электронной почты указанному в п.12 реквизиты сторон.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >2.6. Все дополнения к утвержденной Спецификации к данному Договору,
          после его согласования и подписания Сторонами, оформляются отдельным
          заказом с заключением отдельного Договора.
          <strong><br />&nbsp;</strong>2.7. В случае если изменения вносятся
          Покупателем по истечении 24 часов с момента подписания Договора,
          Продавец вправе потребовать от Покупателя возмещения убытков,
          понесённых в результате исполнения настоящего Договора.<strong
            ><br />&nbsp;</strong
          >2.8. Подписывая Договор, Покупатель подтверждает, что до заключения
          настоящего Договора Продавец предоставил Покупателю полную,
          достоверную и доступную информацию, характеризующую предлагаемый Товар
          и его потребительские свойства, информацию о цене и об условиях
          приобретения товара, о порядке оплаты товара. При наличии образца
          выбранного Товара, Продавец продемонстрировал Покупателю, как выглядит
          выбранный им Товар со всех сторон. Если же Товар был выбран по
          каталогу/через сайт Продавца, то Продавец описал Покупателю, как будет
          выглядеть Товар со всех сторон.<strong><br />&nbsp;</strong>2.9.
          Подписывая Договор, в том числе Спецификацию к нему, Покупатель
          подтверждает, что приобретает Товар, который имел намерение
          приобрести.<strong><br />&nbsp;</strong>2.10. В качестве примера
          Сторонами используются выставочные образцы мебели и рекламные
          материалы в торговой точке Продавца. Согласование комплектации и
          внешнего вида мебели производится путём составления Спецификации (п.
          2.2 Договора).<strong><br />&nbsp;</strong>2.11. Подписывая Договор,
          Покупатель выражает согласие с тем, что допускаются незначительные
          расхождения между внешним видом образцов, представленных на сайте, в
          каталоге или в торговом зале Продавца, и конечным Товаром, если эти
          расхождения касаются оттенка цвета, вариантов распила (раскроя),
          фактуры, оттенка, узора древесины/камня/кожи и прочим отличиям,
          связанным с неоднородностью материала. Покупатель согласен с тем, что
          элементы Товара могут незначительно отличаться друг от друга по
          оттенкам, а также по цвету от представленных образцов, что связано с
          особенностями технологии производства, а также подготовки изображений
          Товара к публикации на сайте или в каталоге. Производитель&nbsp;может
          в одностороннем порядке менять конструктив изделий и материалы для его
          изготовления, если они не приведу к существенным изменениям в
          потребительских свойствах самого изделия и условий его эксплуатации.
          Характеристики материалов не должны отличаться по своим свойствам от
          выбранных Покупателем, но могут иметь расхождения по внешнему виду,
          фактуре, оттенку, узору древесины/ камня/кожи и типа поверхности.
          Вышеперечисленные расхождения не являются недостатками Товара.<strong
            ><br />&nbsp;</strong
          >2.12. Покупатель подтверждает, что при знакомстве с Товаром Продавец
          предоставил Покупателю полную, достоверную и доступную информацию,
          характеризующую предлагаемый Товар. Перед заключением настоящего
          Договора, при наличии образца выбранного Товара, Продавец показал
          Покупателю, как выглядит выбранный Товар со всех сторон. Если же Товар
          был выбран по каталогу/сайту, то Продавец описал Покупателю, как будет
          выглядеть Товар со всех сторон, также составил Дизайн-проект c
          указанием всех необходимых цветов материала, размеров мебели для
          качественной сборки.<strong><br />&nbsp;</strong>2.13. Право
          собственности на товар переходит к Покупателю в момент доставки после
          выполнения условий предусмотренных пунктом 4.5.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >2.14.Стороны</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >договорились,</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >что</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >при</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >приобретении</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >бытовой</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >техники</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >Покупателем</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >самостоятельно,</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >Покупатель</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >обязуется</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >в</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;течении&nbsp;24
          часов&nbsp;после&nbsp;подписания&nbsp;договора&nbsp;предоставить&nbsp;на
          электронную почту -&nbsp;</span
        >
        <a href="mailto:ponomarev@etokuhni.ru"
          ><span style='font-size:10px;font-family:"Times New Roman",serif;'
            >ponomarev</span
          ><span style='font-size:10px;font-family:"Times New Roman",serif;'
            >@</span
          ><span style='font-size:10px;font-family:"Times New Roman",serif;'
            >etokuhni</span
          ><span style='font-size:10px;font-family:"Times New Roman",serif;'
            >.</span
          ><span style='font-size:10px;font-family:"Times New Roman",serif;'
            >ru</span
          ></a
        >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >схемы</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >встройки</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >бытовой</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >техники</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >с</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >указанием</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >моделей</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >техники.</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >В</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >случае</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;не&nbsp;предоставления&nbsp;схем&nbsp;встройки,&nbsp;модули&nbsp;под&nbsp;бытовую&nbsp;технику&nbsp;будут&nbsp;изготовлены&nbsp;по&nbsp;стандартным&nbsp;размерам.&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >3. ОБЯЗАННОСТИ СТОРОН</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >3.1 Продавец обязан: <br />&nbsp;3.1.4. Передать товар, указанный в
          Спецификации, Покупателю в порядке и в сроки, установленные в Разделе
          5 и 6 настоящего Договора.<br />&nbsp;3.1.6. Уведомить Покупателя о
          готовности Товара к отгрузке в срок не позднее 24 (двадцати четырех)
          часов до даты отгрузки Товара (ов) для передачи Покупателю путем
          сообщения данных сведений по электронной почте или номеру телефона,
          указанным в настоящем Договоре.<br />&nbsp;3.2 Покупатель обязан:<br />&nbsp;3.2.1.
          Ознакомиться с информацией об основных потребительских свойствах
          Товара, материалах, из которых он изготовлен и которые использованы
          при его отделке, месте изготовления, цене, цвете, размере, условиях
          приобретения и получения Товара, сроке его службы, гарантийном сроке
          до заключения Договора.<br />&nbsp;3.2.2. Согласовать Дизайн-проект и
          Спецификацию с Продавцом.<br />&nbsp;3.2.3. Оплатить Товар в порядке,
          предусмотренном п.4.4 и 4.5 настоящего Договора.<br />&nbsp;3.2.4.
          Принять товар в согласованный настоящим Договором срок, проверить его
          в порядке, предусмотренном п.6.6 настоящего Договора, подписать
          товарную накладную и в случае необходимости иные документы,
          предусмотренные настоящим Договором. <br />&nbsp;3.2.5. Согласовывать
          с Продавцом внесение изменений в заказанную Спецификацию в срок не
          позднее 24 (Двадцати четырех) часов с момента подписания настоящего
          договора.&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >4. ПОРЯДОК И СРОКИ ОПЛАТЫ</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >4.1. Расчет между Покупателем и Продавцом производится в российских
          рублях, в соответствии со стоимостью Товара,
          <span><slot name="payMethod" />.</span></span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >4.2. Цена Товара (ов) определяется в момент заключения Договора и
          указывается в Спецификации (Приложение №1) и/или Спецификации
          (Приложение №1.1)</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >4.3. Цена Товара, указана в Спецификации и включает в себя стоимость
          услуг Продавца по моделированию, составления дизайн-проекта и создания
          его Спецификации, Товара, а также хранение Товара в течение 7 (Семи)
          календарных дней на складе Продавца, после уведомления Покупателя о
          готовности товара.<br />&nbsp;4.4. Стоимость Товара не включает
          стоимость доставки, сборки, монтажа и иных услуг, которые оказываются
          сторонними организациями.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >4.5. Остаток денежных средств за Товар, указанных в Спецификации,
          Покупатель уплачивает не позднее чем за 3 (три) дня до планируемый
          даты доставки.&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >5. СРОКИ ИСПОЛНЕНИЯ ДОГОВОРА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >5.1. Максимальный срок поставки (отгрузки) Товара для передачи
          Покупателю составляет &nbsp;38 рабочих &nbsp;дней с момента заключения
          Договора.<br />&nbsp;5.2. Подписанием настоящего Договора Покупатель
          выражает согласие на то, что в случае возникновения следующих
          обстоятельств : выход из строя оборудования, увеличение сезонного
          спроса, отсутствие материала или иных комплектующих &nbsp;на складе
          производителя Товара срок исполнения Договора может быть увеличен на
          30 (тридцать) рабочих дней без подписания дополнительного соглашения с
          Покупателем относительно новой даты отгрузки Товара, при этом Продавец
          не считается нарушившим обязательство по передаче Товара в
          установленный срок. О возникших в указанном пункте Договора
          обстоятельствах Продавец уведомляет Покупателя по номеру телефона или
          адресу электронной почты, указанным в настоящем Договоре. <br />
          5.3. Возможная ближайшая дата готовности заказа -
          <span><slot name="readyDate" /> </span>.&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >5.4. Указанный в п. 5.3. настоящего Договора срок устанавливается
          производством и является предварительным.<br />&nbsp;5.5. Стороны
          путем заключения дополнительного соглашения к настоящему Договору
          вправе изменить дату отгрузки Товара.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >5.6 &nbsp;При заказе столешницы из искусственного камня, срок
          выполнения заказа увеличивается на 14 рабочих дней с момента замера
          помещения.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >5.7 &nbsp;При заказе стеклянной стеновой панели, срок выполнения
          заказа увеличивается на 14 рабочих дней с момента замера
          помещения.</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >6. ПЕРЕДАЧА ТОВАРА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >6.1. Товар(ы) по настоящему Договору передается(ются) Покупателю
          одним из следующих способов (выбрать нужное):<br />&nbsp;- самовывоз
          Товара Покупателем;<br />&nbsp;- вывоз Товара иным лицом,
          уполномоченным Покупателем на основании выданной ему доверенности.<br />
          6.2. Адрес, по которому Продавцом осуществляется передача Товара
          покупателю или уполномоченному им лицу:
          <span><slot name="deliveryAddress"/></span><br />&nbsp;6.3. Время и
          дата передачи товара согласовывается сторонами по телефону не позднее
          24 часов до передачи товара.<br />&nbsp;6.4. Передача товара
          осуществляется, только после выполнения Покупателем обязательств по
          оплате согласно п. 4.5. настоящего договора.<br />&nbsp;6.5.
          Обязательства Продавца по передаче Товара считаются выполненными в
          момент отгрузки Товара для передачи Покупателю по адресу, указанному в
          п. 6.2 настоящего Договора.<br />&nbsp;6.6. Осмотр продукции
          производится Покупателем в момент передачи. В случае отказа Покупателя
          от осмотра, Продавец не несет ответственность за механические
          повреждения (делается отметка в накладной). При приемке Товара
          Покупатель (или уполномоченное им лицо) обязан проверить Товар по
          количеству, качеству (общая целостность Товара, наличие недостатков
          (трещин, сколов, потертостей, пятен, разводов и тд), для обнаружения
          которых не требуется применение специального оборудования) и
          комплектности, на его соответствие образцу/описанию Товара, а также
          данным, указанным в Договоре и Спецификации к нему. В случае
          обнаружения недостатков Товара и/или его несоответствия данным,
          отраженным в Договоре и в Спецификации к нему, Сторонами составляется
          соответствующий акт (о браке, о наличии расхождений и т.д.). К акту
          прилагаются фото- и/ или видеоматериалы, подтверждающие обнаруженные
          недостатки.<br />&nbsp;6.7. Передача Товара осуществляется Покупателю
          или иному лицу, оплатившему Товар, или предъявившему Продавцу
          документы на получение товара (кассовый или товарный чек, другие
          документы, связанные с товаром). Оплата товара или предъявление
          документов на товар третьим лицом является подтверждением того, что
          данное лицо является представителем Покупателя и действует в его
          интересах при получении Товара. Передача товара Покупателю или
          уполномоченному лицу оформляется подписанием товарной накладной.<br />&nbsp;6.8.
          Право собственности на Товар и риск случайной гибели или случайного
          повреждения Товара переходит от Продавца к Покупателю с момента
          передачи ему Товара и подписания Покупателем (или уполномоченным им
          лицом) документов, подтверждающих получение Товара.<br />&nbsp;6.9.
          Покупатель согласен с тем, что Товары, реализуемые по одному Договору,
          могут передаваться Покупателю по частям в случае невозможности их
          одновременной доставки или временного отсутствия части Товаров на
          складе. <br />&nbsp;6.10. Покупатель (уполномоченное им лицо) обязан
          принять Товар от Продавца в течение 7(семи) дней после уведомления
          &nbsp; Продавцом &nbsp;Покупателя (уполномоченное им лицо) &nbsp;о
          готовности заказа, но не ранее плановой даты отгрузки предусмотренным
          пунктом 5.4. В случае, если Покупатель (уполномоченное им лицо) не
          принимает Товар в указанный период времени, то Продавец вправе
          направить Покупателю требование об оплате услуг хранения. Услуги
          хранения, оказываемые сверх срока, установленного настоящим пунктом,
          оплачиваются из расчета 500 руб. в сутки. <br />&nbsp;6.11. Доставка,
          подъем и сборка для Покупателя являются дополнительными платными
          услугами и осуществляются сторонними организациями.</span
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >7. ОБМЕН И ВОЗВРАТ ТОВАРА НАДЛЕЖАЩЕГО КАЧЕСТВА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >7.1. Покупатель вправе отказаться от Товара надлежащего качества в
          любое время до его передачи, а после передачи Товара &ndash; в течение
          7 дней, при условии, что товар не был в употреблении, сохранены его
          товарный вид и потребительские свойства.. Индивидуально-определенные
          Товары надлежащего качества возврату и обмену не подлежат.
          Индивидуально-определенными являются любые товары (корпуса,
          столешницы, стеновые панели, фасады, цокольные планки, декоративные
          элементы и т.д.), изготавливаемые и поставляемые по индивидуальным
          размерам на заказ.<br />&nbsp;7.2. Сторонами согласованы следующие
          условия и порядок возврата Товара надлежащего качества:<br />&nbsp;7.2.1.
          Адрес Продавца, по которому осуществляется возврат товара: г. Москва,
          ул. Кировоградская, дом 15.<br />&nbsp;7.2.2. Режим работы Продавца:
          10.00-22.00<br />&nbsp;7.2.3. Товар может быть возвращен Продавцу в
          течение 7 дней с момента передачи его Покупателю.<br />&nbsp;7.2.4.
          Товар не был в употреблении, не подвергался сборке, сохранены его
          товарный вид, заводская упаковка, потребительские свойства, пломбы,
          фабричные ярлыки.<br />&nbsp;7.2.5. Возврат наличных денежных средств
          осуществляется только лицу, производившему оплату, либо лицу,
          уполномоченному на получение денежных средств нотариально
          удостоверенной доверенностью. Возврат денежных средств
          &nbsp;производится не позднее, чем 10 дней с момента возврата
          указанного товара Продавцу.<br />&nbsp;7.2.6. Доставка Продавцу Товара
          надлежащего качества, подлежащего обмену или возврату, осуществляется
          Покупателем собственными силами и за свой счет.<br />&nbsp;7.3. Для
          оформления обмена или возврата Товара надлежащего качества Покупателю
          необходимо обратиться с соответствующим заявлением к Продавцу по
          адресу места продажи Товара. Для принятия решения о возврате,
          Покупатель обязан предоставить в электронном виде фотографии упаковки
          и внешнего вида возвращаемого Товара.<br />&nbsp;7.4. Продавец вправе
          отказать в возврате товара, если при передачи его на склад внешний вид
          товара сильно отличается от изображения на фото материалах,
          предоставленных Покупателем и на основании которых принималось решение
          о возврате, а так же товар не соответствует требованиям п. 7.1.
          настоящего договора.<br />&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >8. ОТВЕТСТВЕННОСТЬ СТОРОН</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >8.1. В случае если Покупателю был передан Товар с нарушением условий
          Договора, касающихся количества, ассортимента, комплектности, тары и
          (или) упаковки Товара, Покупатель вправе не позднее 3 календарных дней
          после получения Товара известить Продавца об этих нарушениях в
          письменном виде с приложением фото-/видеоматериалов, подтверждающих
          обнаруженные недостатки. В противном случае Товар соответствующего
          наименования (артикула) считается принятым без претензий по
          количеству, ассортименту, качеству и комплектности, таре и (или)
          упаковке Товара. <br />&nbsp;8.2. В отношении недостатков, касающихся
          качества Товара, в случае, если они не были оговорены Продавцом,
          требования, предусмотренные законодательством РФ, могут предъявляться
          в течение гарантийных сроков, установленных на Товар соответствующего
          наименования (артикула). <br />&nbsp;8.3. Продавцом на комплектующие
          изделия и составные части Товара могут устанавливаться гарантийные
          сроки, отличные от гарантийных сроков на основное изделие. В случае,
          если на комплектующее изделие и составную часть Товара установлен
          гарантийный срок меньшей продолжительности, чем гарантийный срок на
          основное изделие, Покупатель вправе предъявить требования, связанные с
          недостатками комплектующего изделия и составной части Товара, при их
          обнаружении в течение гарантийного срока на такое комплектующее
          изделие или составную часть Товара. <br />&nbsp;8.4. Покупатель,
          которому продан Товар ненадлежащего качества, Товар с нарушением
          условий Договора о комплектности и /или ассортименте, если это не было
          оговорено Продавцом, вправе предъявить требования, предусмотренные
          законодательством РФ. Требования Покупателя должны быть оформлены в
          письменном виде с приложением документов, фото-, видеоматериалов,
          подтверждающих обоснованность данных требований. Продавец вправе не
          отвечать на письменную претензию Покупателя, если она выставлена
          некорректно или не предоставлены все необходимые фото, видео
          материалы. Предъявленные в соответствии с настоящим пунктом
          требования, в случае признания их обоснованными, удовлетворяются
          Продавцом в течение</span
        ><span
          style='font-size:11px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >60</span
        ><span
          style='font-size:5px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >рабочих дней со дня их предъявления. <br />&nbsp;8.5. Требования,
          предусмотренные п. 8.4 настоящего Договора (о замене Товара, об
          устранении недостатков, об уменьшении покупной цены и т.д.) могут быть
          заявлены только в отношении того Товара (тех Товаров) из Товаров,
          включенных в Спецификацию, в котором были обнаружены недостатки. Эти
          требования не касаются иных Товаров, реализуемых по настоящему
          Договору. В случае предъявления Покупателем требования об отказе от
          Договора и возврате уплаченной за Товар суммы, заявленный Покупателем
          отказ не влечет расторжения Договора в отношении остальных Товаров,
          реализуемых в рамках настоящего Договора.<br />&nbsp;8.6. Не подлежат
          удовлетворению требования Покупателя, связанные с недостатками Товара,
          в случаях:<br />&nbsp;- если недостатки возникли после передачи Товара
          и являются следствием неправильной эксплуатации Товара (эксплуатации
          Товара с нарушением условий, предусмотренных Приложениями к настоящему
          Договору) и использовании не по назначению;<br />&nbsp;- если
          недостатки возникли после передачи Товара вследствие действий третьих
          лиц или непреодолимой силы;<br />&nbsp;- если недостатки возникли по
          причине нарушений условий транспортировки, погрузочно-разгрузочных
          работ, хранения, монтажа.<br />&nbsp;- при наличие на поверхности
          фасадов механических повреждений, термовоздействий или следов
          воздействия химических веществ, попадания большого объема жидкости и
          т. д.<br />&nbsp;- при механических и других повреждениях, возникших
          вследствие естественного износа изделия.<br />&nbsp;8.7. Если Продавец
          передал в нарушение договора Покупателю меньшее количество Товара
          соответствующего наименования (артикула), чем определено Спецификацией
          к Договору, Покупатель вправе потребовать от Продавца недостающее
          количество Товара. В случае неудовлетворения Продавцом заявленного
          требования в разумный срок, Покупатель вправе отказаться от
          переданного Товара соответствующего наименования (артикула) и
          потребовать возврата уплаченной за Товар денежной суммы.<br />&nbsp;8.8.
          В случае нарушения сроков изготовления Товара Продавец уплачивает
          Покупателю за каждый день просрочки неустойку (пени) в размере 0,1 %
          &nbsp;от суммы предварительной оплаты товара.<br />&nbsp;8.9. В
          случае, если в соответствии с законодательством РФ, с Продавца за
          нарушение установленных сроков удовлетворения требований Покупателя,
          подлежит взысканию неустойка, базой для её начисления является цена
          того Товара, в отношении которого Продавцом было нарушено
          обязательство по надлежащему исполнению Договора. <br />&nbsp;8.10.
          Если требования об отказе от Договора и возврате уплаченной за Товар
          денежной суммы будут признаны Продавцом обоснованными и подлежащими
          удовлетворению в добровольном порядке, возврат денежной суммы
          осуществляется Продавцом в порядке, предусмотренном п. 7.2.5
          настоящего Договора.<br />&nbsp;8.11. Продавец не несет
          ответственности за ущерб, причиненный Покупателю вследствие
          ненадлежащего использования им заказанных Товаров.<br />&nbsp;8.12.
          Продавец не отвечает за убытки Покупателя, возникшие в результате
          неправомерных действий третьих лиц, некорректного предоставления
          Покупателем информации.<br />&nbsp;8.13. Продавец не несет
          ответственности за качество оказываемых услуг по доставке, подъему,
          сборке и установке Товара, а также за недостатки, возникшие по причине
          некачественного / несовременного оказания данных услуг. Данные услуги
          оказываются сторонними организациями, к которым могут быть предъявлены
          соответствующие требования.<br />&nbsp;8.14. Продавец не несет
          ответственность за внешние механические повреждения и
          непроизводственный брак, который может быть обнаружен при внешнем
          осмотре Товара и его упаковки, если Покупатель в момент передачи
          Товара осмотрел Товар и не обнаружил недостатков, а равно в случае
          отказа Покупателя от осмотра Товара.<br />&nbsp;8.15. Продавец не
          несет ответственности за точность и правильность контактной
          информации, предоставленной Покупателем. В случае неисполнения
          Продавцом обязательств по причине сообщения Покупателем недостоверных
          сведений о себе, Продавец не несет ответственности за неисполнение (за
          несвоевременное исполнение) обязательств по Договору. Повторные
          действия по исполнению обязательств по Договору производятся только по
          согласованию Сторон с отнесением соответствующих дополнительных
          расходов на Покупателя.<br />&nbsp;8.16. Покупатель до передачи ему
          товара вправе отказаться от исполнения настоящего Договора при условии
          возмещения Продавцу расходов, понесённых в связи с совершением
          действий по выполнению Договора (п.4 ст.497 ГК РФ) в размере денежных
          средств, внесенных в кассу Продавца по Договору.<br />&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >9. ГАРАНТИЙНЫЕ ОБЯЗАТЕЛЬСТВА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >9.1. Качество Товара, передаваемого по настоящему Договору, должно
          соответствовать требованиям ГОСТ 16371-93 и ГОСТ 19917-93.<br />&nbsp;9.2.
          Продавец предоставляет Покупателю гарантию на Товар в течение 24-х
          (Двадцати четырех) месяцев с момента получения товара покупателем на
          продукцию собственного производства и 12-ти (двенадцати) месяцев на
          аксессуары, при соблюдении правил хранения и транспортировки мебели,
          указанных в Приложении № 3 &quot;ПРАВИЛА ЭКСПЛУАТАЦИИ КУХОННОЙ
          МЕБЕЛИ&quot;, являющихся неотъемлемой частью настоящего Договора.
          <br />&nbsp;9.3. В случае обнаружения в течение гарантийного срока
          скрытых дефектов, Покупатель должен обратиться с письменным заявлением
          к Продавцу Товара. Причины возникновения дефектов устанавливаются
          комиссией в составе представителей Продавца и Покупателя. Устранение
          недостатков производится Продавцом в течение срока, указанного в п.
          8.4. договора.<br />&nbsp;9.3.1 При выставлении претензии Продавцу, по
          качеству отгруженного товара, для их устранения и выявления причин
          возникновения, обязательно необходимо предоставить на электронную
          почту -&nbsp;</span
        ><strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >ponomarev</span
          ></strong
        ><strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >@</span
          ></strong
        ><strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >etokuhni</span
          ></strong
        ><strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >.</span
          ></strong
        ><strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >ru</span
          ></strong
        ><span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />&nbsp;1) &nbsp; &nbsp; &nbsp; &nbsp;Номер заказ (указывается в
          теме письма)<br />&nbsp;2) &nbsp; &nbsp; &nbsp; &nbsp;Наименование
          товара согласно товарной накладной <br />&nbsp;3) &nbsp; &nbsp; &nbsp;
          &nbsp;Описание дефекта<br />&nbsp;4) &nbsp; &nbsp; &nbsp;
          &nbsp;Фотографии заводской этикетки на упаковке<br />&nbsp;5) &nbsp;
          &nbsp; &nbsp; &nbsp;Фотографии товара<br />&nbsp;6) &nbsp; &nbsp;
          &nbsp; &nbsp;Фотографии дефекта (при разнооттеночности сравнительное
          фото)<br />&nbsp;7) &nbsp; &nbsp; &nbsp; &nbsp;Фотографию заводской
          этикетки на товаре (если есть)<br />&nbsp;8) &nbsp; &nbsp; &nbsp;
          &nbsp;Фотографии гарантийного талона (если поставляется в комплекте с
          товаром)<br />&nbsp;9.3.2. Если повреждения обнаружились при вскрытии
          заводской упаковки, обязательно предоставление фотографий упаковки
          подтверждающих, что она не имеет механических повреждений. Если
          повреждённый товар установлен, а упаковка утилизирована, считается что
          повреждение возникло в процессе эксплуатации.<br />&nbsp;9.3.3. Если
          претензия по несоответствию заявленных размеров товара, обязательно
          предоставление фотографии изделия с рулеткой.<br />&nbsp;9.3.4. Если
          дефект обнаружен в процессе эксплуатации, дополнительно необходимо
          прислать фотографии с общим планом, где установлено изделие с
          недостатками.<br />&nbsp;9.3.5. Обслуживание техники производится на
          дому силами авторизованного сервисного центра.<br />&nbsp;9.3.6.
          Продавец в праве отказать в претензии Покупателя, если она выставлена
          не корректно или не предоставлены все необходимые фотоматериалы.<br />&nbsp;Гарантийное
          обслуживание не производится в случаях:<br />
          - При нарушении условий эксплуатации <strong>Приложении № 3</strong>
          <strong>&quot;ПРАВИЛА ЭКСПЛУАТАЦИИ КУХОННОЙ МЕБЕЛИ&quot;.</strong
          ><br />&nbsp;- При наличии следов механического повреждения, при
          превышении предельно-допустимых нагрузок на изделие, при нанесении
          ущерба вследствие попадания внутрь изделия посторонних предметов
          (жидкости и т.п.).<br />&nbsp;- В случае наличия следов постороннего
          вмешательства предприятиями, организациями или частными лицами, не
          уполномоченными Продавцом с целью ремонта изделия или изменения
          конструкции.<br />&nbsp;- При нарушении условий транспортировки
          Товара.<br />&nbsp;9.4. Дополнительные заказы рекламационные заказы
          &nbsp;на фасады МДФ пленка, шпон дерева, шпон камня и эмаль могут
          отличаться по цвету. Рекламации в данном случае приниматься не
          будут.</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >10. ФОРС-МАЖОРНЫЕ ОБСТОЯТЕЛЬСТВА</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >10.1. Стороны освобождаются от ответственности за полное или
          частичное неисполнение своих обязательств, если такое неисполнение
          явилось следствием действия форс-мажорных обстоятельств.
          Форс-мажорными признаются обстоятельства, которые по своему характеру
          являются чрезвычайными, непредвиденными, не зависящими от воли сторон
          и относятся к явлениям, не связанным с деятельностью сторон. Стороны
          признают, что к форс-мажорным обстоятельствам относятся следующие
          явления: военные действия, террористические акты, природные аномалии.
          Не могут быть признаны обстоятельствами форс-мажора
          финансово-экономический кризис, изменения курса валют, девальвация
          национальной валюты, арест или приостановление операций по счетам.
          Введение международными и (или) государственными (муниципальными)
          органами власти запретительных (ограничительных) мер, в том числе, при
          массовых заболеваниях (эпидемиях, эпизоотии, пандемии) может быть
          воспринято как обстоятельство форс-мажора только в том случае, если
          невозможность исполнения конкретного обязательства в надлежащие сроки
          причинно обусловлена действием данных мер. <br />&nbsp;10.2. При
          наступлении обстоятельств форс-мажора, Сторона, ссылающаяся на эти
          обстоятельства в качестве основания освобождения от ответственности,
          должна письменно уведомить другую сторону в течение 5 (пяти)
          календарных дней о наступлении данных обстоятельств. <br />&nbsp;10.3.
          В случае наступления обстоятельств, указанных в п.10.1 настоящего
          Договора, срок выполнения стороной обязательств отодвигается
          соразмерно времени, в течение которого действуют эти обстоятельства и
          их последствия.&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >11. ПРОЧИЕ УCЛОВИЯ</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:normal;font-size:15px;">
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >11.1. Подписывая настоящий договор, Покупатель гарантирует, что
          полностью ознакомился с текстом настоящего Договора и принимает его
          условия.<br />&nbsp;11.2. Любые изменения и дополнения к настоящему
          Договору действительны только в том случае, если они совершены в
          письменной форме и подписаны представителями обеих Сторон.<br />&nbsp;11.3.
          Дополнения к основному заказу оформляются при помощи дополнительного
          заказа.<br />&nbsp;11.3.1. Оформление дополнительного заказа возможно
          только в течении 2 суток, с момента оформления основного заказ. В этом
          случае передача этих заказов Покупателю будет осуществляться
          совместно. Если дополнительный заказ оформлен по истечении этого
          срока, то передача такого заказа Покупателю осуществляется отдельно от
          основного заказ, а совместная передача этих заказов возможна только
          при оплате услуги хранения основного заказа согласно п. 6.10.
          настоящего договора. &nbsp;<br />&nbsp;11.3.2. Дополнительный заказ на
          фасады из МДФ в пленке и эмали не принимаются и оформляются отдельным
          заказом. Передача этих заказов Покупателю осуществляется отдельно, а
          совместная передача возможна только при оплате услуги хранения
          основного заказа согласно п. 6.10. настоящего договора.<br />&nbsp;11.4.
          В случаях, не предусмотренных настоящим Договором, Стороны
          руководствуются действующим гражданским законодательством.<br />&nbsp;11.5.
          При возникновении в процессе исполнения настоящего Договора спора,
          который Стороны не смогут урегулировать путем переговоров, спор будет
          разрешаться в Чертановском районом суде г. Москве. <br />&nbsp;11.6.
          Настоящий Договор вступает в силу с момента его подписания и действует
          до полного исполнения Сторонами своих обязательств по нему.<br />&nbsp;11.7
          Настоящий Договор составлен в двух экземплярах, по одному для каждой
          из Сторон.</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:11px;font-family:"Times New Roman",serif;color:black;'
            >12. РЕКВИЗИТЫ И ПОДПИСИ СТОРОН</span
          ></strong
        >
      </p>
      <table style="border: none;">
        <tbody>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Продавец: ИП Пономарев Алексей Михайлович</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Покупатель: <span><slot name="buyer" /> </span
                ></span>
              </p>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Юр. адрес: 117628, г. Москва, ул. Куликовская д.1, кв.
                  19</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >ФИО: <span><slot name="fullName"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Факт. адрес: г. Москва, ул. Кировоградская, д.15</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Дата рождения: <span><slot name="birthday"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >ИНН: 772773538530</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Паспорт:<span><slot name="passport"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Р/сч.: 40802810638000095229</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Адрес регистрации: <span><slot name="registration"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Кор./сч.: 30101810400000000225</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Адрес доставки:
                  <span><slot name="deliveryAddress"/></span>&nbsp;</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >В банке: ПАО СБЕРАНК</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Телефон: <span><slot name="phoneMain"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >В городе: Москва</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Дополнительный телефон: <span><slot name="phoneOther"/></span
                ></span>
              </p>
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Почта для официальных писем :
                  <span><slot name="email"/></span
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >БИК: 044525225</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Тел: 8</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >&nbsp;</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >495</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >&nbsp;</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >004 42 83</span
                >
              </p>
              <p style="margin:0cm;line-height:normal;font-size:15px;">
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >Почта для официальных писем :&nbsp;</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >ponomarev</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >@</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >etokuhni</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >.</span
                ><span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >ru</span
                >
              </p>
            </td>
            <td style="padding:0cm 0cm 0cm 0cm;">
              <p
                style="margin:0cm;line-height:normal;font-size:15px;text-align:  center;"
              >
                <span
                  style='font-size:11px;font-family:"Times New Roman",serif;'
                  >&nbsp;</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />&nbsp;<br />&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <strong
          ><span
            style='font-size:11px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <strong
          ><span
            style='font-size:11px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          ><br />
          <strong>Подписи сторон.</strong></span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:justify;"
      >
        <span
          style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
          >Продавец ____________ / &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;/ &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; Покупатель ____________ / &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; /</span
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >&nbsp;</span
          ></strong
        >
      </p>
    </div>

    <div class="page-break">
      <p
        style="margin:0cm;line-height:normal;font-size:15px;text-align:center;"
      >
        <strong
          ><span
            style='font-size:10px;font-family:"Times New Roman",serif;color:black;'
            >13. ПРИЛОЖЕНИЯ К ДОГОВОРУ</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          ><br />&nbsp;Приложение №1 и/или &nbsp;Приложение №1.1 &nbsp;-
          Спецификация. <br />&nbsp;Приложение №2 - Дизайн-проект.
          <br />&nbsp;Приложение №3 - Эксплуатационные правила мебели..<br />&nbsp;Приложение
          №4 - Технические условия.</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >Приложение №5 Требования по подготовке помещений к монтажу
          кухни</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>

      <br />
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <strong
          ><span
            style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
            >ПРИЛОЖЕНИЕ №1.1 - СПЕЦИФИКАЦИЯ.&nbsp;</span
          ></strong
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <span
          style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
          >&nbsp;</span
        >
      </p>

      <slot name="table" />
    </div>

    <div class="page-break">
      <p style="margin:0cm;line-height:107%;font-size:15px;text-align:center;">
        <strong
          ><span
            style='font-size:10px;line-height:107%;font-family:"Times New Roman",serif;color:black;'
            >ПРИЛОЖЕНИЕ №2 &ndash; ДИЗАЙН-ПРОЕКТ.&nbsp;</span
          ></strong
        >
      </p>
      <br />

      <slot name="photo" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Print-text"
};
</script>
